import precisionMedium from './chunks/precision.medium.glsl.js';
import defaultAttributes from './chunks/default.attributes.glsl.js';
import defaultVaryings from './chunks/default.varyings.glsl.js';
var shaderPassVS = precisionMedium + defaultAttributes + defaultVaryings + "\nvoid main() {\n    vTextureCoord = aTextureCoord;\n    vVertexPosition = aVertexPosition;\n    \n    gl_Position = vec4(aVertexPosition, 1.0);\n}\n";
export default shaderPassVS.replace(/\n/g, '');